import { Reveal, MaskReveal } from "@/components/Reveal";

const SectionHeader = ({ eyebrow, lines, sub, dark = false, align = "left", index }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`} data-testid={`section-${lines?.[0]?.slice(0, 20).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
    <Reveal>
      <div className="flex items-center gap-4">
        {index && <span className={`font-mono text-[11px] tracking-[0.22em] ${dark ? "text-pine-2" : "text-pine"}`}>{index}</span>}
        <p className={dark ? "eyebrow-dark" : "eyebrow"}>{eyebrow}</p>
        <span className={`h-px flex-1 max-w-16 ${dark ? "bg-coalline" : "bg-line"}`} aria-hidden="true" />
      </div>
    </Reveal>
    <MaskReveal
      lines={lines}
      className={`mt-4 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] ${dark ? "text-ivory" : "text-ink"}`}
    />
    {sub && (
      <Reveal delay={0.2}>
        <p className={`mt-6 text-base sm:text-lg leading-relaxed ${dark ? "text-[#A0A09C]" : "text-dim"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);

export default SectionHeader;
